import { AsyncPipe, CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { InvestmentWizardService } from '../../../investment-wizard/services/investment-wizard-service.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-fund-family-search',
  templateUrl: './fund-family-search.component.html',
  styleUrls: ['./fund-family-search.component.scss'],
  imports: [
    MatAutocompleteModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    CommonModule,
    MatProgressSpinnerModule,
  ],
})
export class FundFamilySearchComponent implements OnInit {
  private iws = inject(InvestmentWizardService);

  @Input() placeholder = 'Search fund families';
  @Output() selected = new EventEmitter<any>();

  searchControl = new FormControl('');
  dropdownLoading: boolean = false;
  dropdownNoResults: boolean = false;
  filteredFamilies: any[] = [];

  private familyList: any[] = [];

  constructor() {}

  ngOnInit(): void {
    this.dropdownLoading = true;
    this.iws.fundFamilyList().subscribe({
      next: data => {
        this.familyList = data.results ?? [];
        this.filteredFamilies = data.results ?? [];
        this.dropdownLoading = false;
      },
      error: () => {
        this.familyList = [];
        this.filteredFamilies = [];
        this.dropdownNoResults = true;
        this.dropdownLoading = false;
      },
    });

    this.searchControl.valueChanges.subscribe(
      (val: string | { ID: number; Name: string } | any) => {
        if (val) {
          this.filteredFamilies = this.familyList.filter(fam =>
            fam.Name.toLowerCase().includes(
              typeof val === 'string'
                ? val?.toLowerCase()
                : val.Name.toLowerCase()
            )
          );
          this.dropdownNoResults = this.filteredFamilies.length === 0;
        } else {
          this.filteredFamilies = [...this.familyList];
        }
      }
    );
  }

  select(item: any) {
    this.selected.emit(String(item.ID));
  }

  displayFn(val: any): string {
    return val?.Name ?? '';
  }
}
